import { BaseClass } from './base'

export class NewsClass extends BaseClass {
  modelRef = {
    title: '',
    sign: '',
    thumbnail: '',
    brief: '',
    content: '',
    publishTime: null,
    publishStatus: 0,
    newsTypeId: 0,
    isHomeShow: false,
    isTop: 0,
    readTimes: 0,
    like: 0
  }

  rulesRef = {
    title: [
      {
        required: true,
        message: '请输入标题'
      }
    ],
    content: [
      {
        required: true,
        message: '请输入内容'
      }
    ],
    newsTypeId: [
      {
        required: true,
        message: '请选择分类'
      }
    ]
  }

  gets (params) {
    return this.get(this.news, params)
  }

  create (data) {
    return this.post(this.news, data)
  }

  update (data) {
    return this.put(this.news, data)
  }

  del (id) {
    return this.delete(this.news + `/${id}`)
  }

  status (id, status) {
    return this.get(this.news + `/${id}/${status}`)
  }

  top (id, status) {
    return this.get(this.news + `/ChangeIsTop/${id}/${status}`)
  }

  home (id, status) {
    return this.get(this.news + `/ChangeIsHomeShow/${id}/${status}`)
  }
}

export class NewsTypeClass extends BaseClass {
  modelRef = {
    name: '',
    parentId: 0,
    sortNum: 0
  }

  rulesRef = {
    name: [
      {
        required: true,
        message: '请输入标题'
      }
    ]
  }

  gets (params) {
    return this.get(this.newsType, params)
  }

  create (data) {
    return this.post(this.newsType, data)
  }

  update (data) {
    return this.put(this.newsType, data)
  }

  del (id) {
    return this.delete(this.newsType + `/${id}`)
  }

  sort (id, sort) {
    return this.get(this.newsType + `/${id}/${sort}`)
  }

  home (id, status) {
    return this.get(this.newsType + `/SetHomeShow/${id}/${status}`)
  }
}
